import React from "react";

export default function MSAccess_MonthName() {
  return (
    <div className="p-4">
      <h1 className="text-2xl font-bold">MSAccess_MonthName</h1>
      <p>This is the MSAccess_MonthName component generated from the SQL JSON.</p>
    </div>
  );
}
